import { Box, Button, Typography } from '@mui/material';
import Spinner from 'components/Spinner';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { Callable } from 'common/frontend/callable';
import { useTranslation } from 'services/localization';

interface Props {
	accountId: string | null;
	text: string;
	variant?: 'outlined' | 'text' | 'contained';
	color?: 'primary' | 'secondary';
}

export const SetUpButton = ({ accountId, text, variant = 'text', color }: Props) => {
	const activeShopId = useSelector(ShopSelectors.activeShopId)!;
	const [redirectLoading, setRedirectLoading] = useState<boolean>(false);
	const [onboardingError, setOnboardingError] = useState<string | undefined>();
	const { t } = useTranslation();

	const handleStripeRedirect = async () => {
		setRedirectLoading(true);
		const onboardingResult = await Callable.paymentAccounts.stripe.onboard({
			origin: window.location.origin,
			shopId: activeShopId,
			accountId: accountId ?? undefined,
		});
		setRedirectLoading(false);
		if (onboardingResult.error) {
			setOnboardingError(onboardingResult.error);
		} else if (onboardingResult.onboardingUrl) {
			window.location.href = onboardingResult.onboardingUrl;
		}
	};

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
			<Button variant={variant} color={color} onClick={handleStripeRedirect}>
				{redirectLoading ? <Spinner padding={8} color="inherit" /> : text}
			</Button>
			{onboardingError && (
				<Typography variant="caption" color="error" sx={{ mt: 1 }}>
					{t(
						'account.payments.errorOccurdedContactSupport',
						'An error occured, please try again or contact support.',
					)}
				</Typography>
			)}
		</Box>
	);
};
